import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "../context/context";
import { http } from "../../src/services/httpService";
import config from "../../src/services/config.json";
import { Avatar, Button, Input, Space, Table, Typography } from "antd";
import { Tag } from "antd";
import moment from "jalali-moment";
import { SearchOutlined } from "@ant-design/icons";

const Users = () => {
    const { setForceUpdate, forceUpdate } = useContext(context);
    //states
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    //persian
    const PN = require("persian-number");
    //api
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Analytic/allUser`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, []);

    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        console.log(dataIndex);
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "address"
                ? (record[dataIndex]?.toString() || "")
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : (record[dataIndex]?.toString() || "")
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });

    console.log(tableData);
    const columns = [
        {
            title: "پروفایل کاربر",
            dataIndex: "coverPic",
            width: "1%",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={`${coverPic?.address}`} alt="cover" />}
                />
            ),
        },
        {
            title: "نام کاربر",
            dataIndex: "name",
            ...getColumnSearchProps("name"),
            width: "2%",
            render: (_, { name }) => (
                <Typography.Paragraph>
                    {name ? (
                        name
                    ) : (
                        <Tag color="red">نام کاربر ثبت نشده است</Tag>
                    )}
                </Typography.Paragraph>
            ),
        },
        {
            title: "آدرس کاربر",
            dataIndex: "address",
            ...getColumnSearchProps("address"),

            width: "10%",
            render: (_, { address }) => (
                <Typography.Paragraph>
                    {address ? (
                        address
                    ) : (
                        <Tag color="orange">آدرس ثبت نشده است</Tag>
                    )}
                </Typography.Paragraph>
            ),
        },
        {
            title: "ایمیل",
            dataIndex: "email",
            width: "5%",
            render: (_, { email }) => (
                <>
                    <Typography.Paragraph>
                        {email ? (
                            email
                        ) : (
                            <Tag color="orange">ایمیل ثبت نشده است</Tag>
                        )}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "تاریخ ورود",
            dataIndex: "createdAt",
            width: "10%",

            render: (_, { createdAt }) => (
                <>
                    <Typography.Paragraph>
                        {PN.convertEnToPe(
                            moment(createdAt.slice(0, 10), "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                        )}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "شماره همراه",
            dataIndex: "username",
            width: "2%",
            render: (_, { username }) => (
                <Typography.Paragraph>
                    {PN.convertEnToPe(username)}
                </Typography.Paragraph>
            ),
        },
    ];
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
            />
        </>
    );
};

export default Users;
